import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { User } from '@/modules/user/models/User';

export class MeetingInviteeObject extends BaseModel {
  user: User;
  isGuest: boolean;

  constructor(model: Partial<MeetingInviteeObject> = {}) {
    super(model);

    this.user = User.mapModel(model.user);
    this.isGuest = model.isGuest as boolean;
  }
}
